var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['rds-spinner', _vm.colorClass, _vm.sizeClass],domProps:{"textContent":_vm._s(_vm.txtLoading)}})}
var staticRenderFns = []

export { render, staticRenderFns }